import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const { defineMultiStyleConfig: o, definePartsStyle: n } = e([
  "container",
  "mainContainer",
  "mainLinksContainer",
  "logos",
  "copyright",
  "socialsContainer",
  "socialsLink",
  "topContainer",
  "topContent1",
  "topContent2"
]), i = n((t) => ({
  container: {
    flexDir: "column"
  },
  mainContainer: {
    bg: "teal.800",
    flexWrap: "wrap",
    alignItems: "center",
    columnGap: 4
  },
  mainLinksContainer: {
    "span:last-child": {
      a: { borderRightWidth: 0 }
    },
    a: {
      cursor: "pointer",
      textStyle: "bodyBoldSmall",
      color: "white",
      textDecorationColor: "white",
      whiteSpace: "nowrap",
      _hover: {
        color: "teal.50",
        textDecorationColor: "teal.50"
      },
      _active: {
        color: "teal.200",
        textDecorationColor: "teal.200"
      }
    },
    [`@media screen and (min-width: ${t.theme.breakpoints.md})`]: {
      a: {
        paddingRight: 4,
        borderRight: "1px solid white"
      }
    }
  },
  logos: {
    gap: 2,
    flex: 0,
    marginRight: "88px"
  },
  copyright: {
    color: "teal.100",
    whiteSpace: "nowrap",
    textStyle: "bodySmall"
  },
  socialsContainer: {
    gap: 6,
    justifyContent: "flex-end",
    flexWrap: "wrap",
    rowGap: 1
  },
  socialsLink: {
    color: "white",
    textDecoration: "none",
    lineHeight: "32px",
    width: "32px",
    fontSize: "18px",
    borderRadius: "full",
    textAlign: "center",
    display: "inline-block",
    _hover: {
      color: "teal.600",
      bg: "gray.100"
    },
    _active: {
      color: "teal.700",
      bg: "gray.200"
    },
    [`@media screen and (min-width: ${t.theme.breakpoints.md})`]: {
      lineHeight: "40px",
      width: "40px",
      fontSize: "20px"
    }
  },
  topContainer: {
    backgroundColor: "white",
    flexWrap: "wrap",
    columnGap: 10
  },
  topContent1: {
    flex: 1
  },
  topContent2: {}
})), r = o({
  baseStyle: i,
  variants: {},
  defaultProps: {}
});
export {
  r as default
};
